import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'translation', // Main translations namespace
    // List all available namespaces - they load on demand
    ns: ['translation', 'login'], // Include both namespaces
    // Preload only login namespace to avoid loading main translation on login page
    preload: [],
    // debug: import.meta.env.DEV, // Commented out to reduce console logs
    
    interpolation: {
      escapeValue: false,
    },
    
    backend: {
      // Support both patterns: /locales/{language}.json and /locales/{namespace}-{language}.json
      loadPath: (_lng: string[], ns: string[]) => {
        // For login namespace, use login-{lng}.json pattern
        if (ns[0] === 'login') {
          return `/locales/login-{{lng}}.json`;
        }
        // For other namespaces, use default pattern
        return '/locales/{{lng}}.json';
      },
      addPath: '/locales/add/{{lng}}',
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
    
    // Load additional namespaces on demand
    partialBundledLanguages: true,
    
    // Don't load the default namespace on initialization
    load: 'currentOnly',
  });

export default i18n;
